<!-- 项目文件 -->
<template>
    <div class="w100p ">
        <Header></Header>
        <Titleimg :img="bgImg"></Titleimg>
        <div class="pt25 pl16 pr16">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    关于我们
                </span>
            </p>
            <div class="pt16 mt16 pb16 pr16 pl16 bgebf">
                <p class="fs16 c3f8 fbold">公司简介</p>
                <div class="pt8 c333 fs13 textindent lh20">
                        江苏车里车外信息技术有限公司成立于2015年，是全国唯一将驾培行业理论教学与线下培训全维度打通，并实现实际运用生产与智能驾校解决方案的系统与服务提供商。致力于将智能、便捷、高效的驾培体验与服务带入每个学员、每个驾校、每个组织，构建智能互联的驾培汽车世界。
                </div>
            </div>
        </div>

        <div class="w100p mt8 bg105">
            <div class="disinblock pl16 pr16 w100p box aa">
            <img class="imgauto" src="../../../public/img/fengmian.png" alt="">
            </div>
            <div class="pt32 pl16 pr16">
               <P class="fs20 fbold c1f8 w70p lh28">
                    我们是智能驾校解决方案的
                    系统与服务提供商
               </P>
               <div class="fs14 c333 textindent lh24 pt16">
                    江苏车里车外信息技术有限公司专业打造的「e学e驾」智能驾培系统在驾驶培训行业领域为客户提供通信网络、IT、智能终端和云服务等有竞争力、安全可信赖的产品、解决方案与服务，与生态伙伴开放合作，持续为客户创造价值，释放驾校潜能，丰富学员需求，激发行业创新。江苏车里车外坚持围绕客户需求持续创新，加大技术研究与服务投入，厚积薄发，推动行业升级、进步。
               </div>
               <p class="pt10">
                   <img class="imgauto" src="../../../public/img/img99.png" alt="">
               </p>
            </div>
        </div>

        <div class=" pl16 pr16 pb30 pt25 bgf9">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    我们为驾培行业创造价值
                </span>
            </p>
            <div class="pt15 bradius2 ">
                <van-row class="" gutter="20">
                    <van-col span="12" class="mt15">
                        <div class="box-shadow22 pt16  bgfff pl16 pr16 minh300">
                            <P class="posre overflow h27">
                                <span class="fs14 c333 fbold floatl  h100p alit">
                                    01
                                </span>
                                <span class="floatr">
                                    <img class="w30 h27" src="../../../public/img/img100.png" alt="">
                                </span>
                            </P>
                            <p class="pt4 pb8" style="color:#45AFFB">为客户创造价值</p>
                            <div class="c666 fs12 lh20">
                                e学e驾为驾培行业用户提供高效便捷的驾培管理系统 ，为学员用户提供一站式的应用服务，真正的帮助驾校合作伙伴降本增效，提升产能，让学员用户享受高品质、便捷的驾培驾考与增值服务体验。
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12" class="mt15">
                        <div class="box-shadow22 pt16  bgfff pl16 pr16 minh300">
                            <P class="posre overflow h27">
                                <span class="fs14 c333 fbold floatl  h100p alit">
                                    02
                                </span>
                                <span class="floatr">
                                    <img class="w27 h27" src="../../../public/img/img101.png" alt="">
                                </span>
                            </P>
                            <p class="pt4 pb8" style="color:#FFB347">促进行业的转型</p>
                            <div class="c666 fs12 lh20">
                                e学e驾为驾培行业的参与者提供完整的经营、培训、营销解决方案，将行业传统单一的经营模式通过ICT、方式、融入LBS与数据云计算，实现驾校运营线上线下无缝对接，提高产能与服务质量，完成升级转型。
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12" class="mt15">
                        <div class="box-shadow22 pt16  bgfff pl16 pr16 minh300">
                            <P class="posre overflow h27">
                                <span class="fs14 c333 fbold floatl  h100p alit">
                                    03
                                </span>
                                <span class="floatr">
                                    <img class="w27 h27" src="../../../public/img/img102.png" alt="">
                                </span>
                            </P>
                            <p class="pt4 pb8" style="color:#ED4605">催化驾培产业的升级</p>
                            <div class="c666 fs12 lh20">
                                e学e驾为驾校提供完整的服务供应链，整合社会行业资源，协助驾校挖掘产业价值，延伸产品链，开拓新的经营点，创造价值。
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12" class="mt15">
                        <div class="box-shadow22 pt16  bgfff pl16 pr16 minh300">
                            <P class="posre overflow h27">
                                <span class="fs14 c333 fbold floatl  h100p alit">
                                    04
                                </span>
                                <span class="floatr">
                                    <img class="w27 h27" src="../../../public/img/img103.png" alt="">
                                </span>
                            </P>
                            <p class="pt4 pb8" style="color:#ED05D4">促动产业链良性发展</p>
                            <div class="c666 fs12 lh20">
                                e学e驾主张开放、合作、共赢，与客户、伙伴合作创新、扩大产业价值，形成健康良性的产业生态系统。通过协助驾培行业转型与提升行业产能，聚拢专项客户流量，为驾培后市场服务提供高品质的消费流量资源，推动产业生态系统的良性发展。
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12" class="mt15">
                        <div class="box-shadow22 pt16  bgfff pl16 pr16 minh300">
                            <P class="posre overflow h27">
                                <span class="fs14 c333 fbold floatl  h100p alit">
                                    05
                                </span>
                                <span class="floatr">
                                    <img class="w27 h27" src="../../../public/img/img104.png" alt="">
                                </span>
                            </P>
                            <p class="pt4 pb8" style="color:#16D58F">保障行业稳定生产</p>
                            <div class="c666 fs12 lh20">
                                e学e驾产品的应用对驾培行业的可持续发展与稳定性起着积极推动的作用。2020年，新冠疫情后，因e学e驾系统的运用，可有效降低驾校培训聚集密度，减少因聚集传播的可能性，帮助合作驾校优先复工，快速恢复产能。
                            </div>
                        </div>
                    </van-col>
                    <van-col span="12" class="mt15">
                    
                    </van-col>
                </van-row>
            </div>
           
        </div>
        <div class="bgfff pl16 pr16 posre pt25 pb90">
            <div class="pb25">
                <p class="fs16 c333 disinblock posre textc w100p flexc ">
                    <span class="border-bottom1">
                        企业荣誉
                    </span>
                </p>
            </div>
            <div class="w100p overflow pt20 posre minh200">
                <swiper ref="mySwiper" :options="swiperOptions" style="height: 200px;" class="posab zindex999 w100p h200 left0 top0 zindex-1 zoom1 indexbg">
                    <swiper-slide style="height: 200px;">
                        <img class="h200" src="../../../public/img/img260.png" alt="">
                    </swiper-slide>
                    <swiper-slide style="height: 200px;">
                        <img class="h200" src="../../../public/img/img261.png" alt="">
                    </swiper-slide style="height: 200px;">
                    <swiper-slide>
                        <img class="h200" src="../../../public/img/img262.png" alt="">
                    </swiper-slide style="height: 200px;">
                    <swiper-slide>
                        <img class="h200" src="../../../public/img/img263.png" alt="">
                    </swiper-slide style="height: 200px;">
                    <swiper-slide>
                        <img class="h200" src="../../../public/img/img264.png" alt="">
                    </swiper-slide style="height: 200px;">
                    <swiper-slide style="height: 200px;">
                        <img class="h200" src="../../../public/img/img265.png" alt="">
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
      
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Titleimg from '@/components/Titleimg';
    //视频
    import {
        videoPlayer
    } from 'vue-video-player'
    import 'video.js/dist/video-js.css'

    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../../public/img/img97.png'),

                swiperOptions: {
                    loopedSlides: 2,
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    loop: true,
                    speed: 2000,
                    spaceBetween: 30,
                    autoplay: {
                        stopOnLastSlide: false,
                        delay: 3000
                    },
                    autoplay: 3000,
                    autoplayDisableOnInteraction: false,
                    pagination: '.swiper-pagination',
                }

            };
        },
        components: {
            Header,
            Titleimg,
            Footer,
            videoPlayer,
        },

        methods: {

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bg105 {
        background-image: url('../../../public/img/img105.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    
    .video-js .vjs-icon-placeholder {
        width: 100%;
        height: 100%;
        display: block;
    }
    
    .vjs-custom-skin>.video-js .vjs-poster {
        border-radius: 0px;
    }
    
    .video-js .vjs-slider {
        border-radius: 0;
    }
    
    .vjs-custom-skin>.video-js .vjs-play-progress,
    .vjs-custom-skin>.video-js .vjs-volume-level {
        border-radius: 0em;
    }
    
    .vjs-custom-skin {
        border-radius: 0px;
        overflow: hidden;
    }
    
    /deep/ .swiper-pagination {
        bottom: 0px;
    }
    
    /deep/.swiper-container {
        padding-bottom: 20px;
    }
</style>